import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Trans } from 'react-i18next';
import { setTourAsViewed } from '../../actions/user';

import { Checkbox, Flex, Text, Button, Divider, Title, Link } from '@homeexchange/design';
import i18n from '../../i18n';

export const termsOfUseTourName = 'terms-of-use-january-6-2026';

export class TermsOfUsePopup extends React.PureComponent {
    static propTypes = {
        hasViewedTermsOfUseTour: PropTypes.bool,
        setTourAsViewed: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            loading: false,
            checkbox: false,
            dataCheckbox: false,
            error: false,
            checkboxTooltip: false
        };

        this.triggerPopup = this.triggerPopup.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onDataCheckboxChange = this.onDataCheckboxChange.bind(this);
        this.onApprove = this.onApprove.bind(this);
    }

    isOnLegalPage() {
        if (typeof window === 'undefined') return false;

        const currentPath = window.location.href;

        const legalUrls = [
            i18n.t('url:link_terms-of-use'),
            i18n.t('url:link_privacy-policy'),
            i18n.t('url:link_code-of-conduct')
        ];

        return legalUrls.some((url) => url && currentPath.includes(url));
    }

    triggerPopup() {
        if (this.state.show) return;

        this.setState({
            show: true,
            error: false
        });
    }

    onCheckboxChange() {
        this.setState({
            checkbox: !this.state.checkbox,
            checkboxTooltip: false,
            error: false
        });
    }

    onDataCheckboxChange() {
        this.setState({
            dataCheckbox: !this.state.dataCheckbox,
            error: false
        });
    }

    onApprove() {
        if (this.state.checkbox && this.state.dataCheckbox) {
            this.setState({
                loading: true,
                error: false,
                checkboxTooltip: false
            });
            return this.props.setTourAsViewed(termsOfUseTourName).then(
                () => {
                    this.setState({
                        show: false,
                        loading: false
                    });
                },
                () => {
                    this.setState({
                        loading: false,
                        error: true
                    });
                }
            );
        } else {
            this.setState({
                checkboxTooltip: true
            });
        }
    }

    renderMainBody() {
        const termsOfUseLink = (
            <Link key="termsOfUseLink" external href={i18n.t('url:link_terms-of-use')} target="_blank">
                link
            </Link>
        );
        const privacyPolicyLink = (
            <Link key="privacyPolicyLink" external href={i18n.t('url:link_privacy-policy')} target="_blank">
                link
            </Link>
        );
        const codeOfConductLink = (
            <Link key="codeOfConductLink" external href={i18n.t('url:link_code-of-conduct')} target="_blank">
                link
            </Link>
        );

        const isFormValid = this.state.checkbox && this.state.dataCheckbox;

        return (
            <Modal.Body>
                <Flex direction="row" gap="4">
                    <Title level={3}>{i18n.t('common:terms-of-use-popup.title')}</Title>
                    <Text>
                        <Trans
                            i18nKey="common:terms-of-use_popup_desc"
                            components={[termsOfUseLink, codeOfConductLink, privacyPolicyLink]}
                            i18n={i18n}
                        />
                    </Text>
                </Flex>
                <Divider />
                <div className="modal-terms-of-use-checkbox">
                    <Flex direction="row" alignItems="start" flexWrap="nowrap" gap="12px">
                        <Checkbox
                            id="terms-accepted"
                            checked={this.state.checkbox}
                            onChange={this.onCheckboxChange}
                            value="terms-accepted"
                        />
                        <label htmlFor="terms-accepted" style={{ cursor: 'pointer', marginTop: '2px' }}>
                            <Text>{i18n.t('common:terms-of-use_popup_checkbox_ToU')}</Text>
                        </label>
                    </Flex>

                    {this.state.checkboxTooltip && (
                        <div className="help-block">
                            {i18n.t('common:terms-of-use-popup.checkbox.tooltip')}
                        </div>
                    )}
                </div>
                <div className="modal-data-migration-checkbox">
                    <Flex direction="row" alignItems="start" flexWrap="nowrap" gap="12px">
                        <Checkbox
                            id="data-terms-accepted"
                            value="data-terms-accepted"
                            checked={this.state.dataCheckbox}
                            onChange={this.onDataCheckboxChange}
                        />
                        <label htmlFor="data-terms-accepted" style={{ cursor: 'pointer', marginTop: '2px' }}>
                            <Text>
                                <Trans
                                    i18nKey="common:terms-of-use_popup_checkbox_privacy"
                                    components={[privacyPolicyLink]}
                                    i18n={i18n}
                                />
                            </Text>
                        </label>
                    </Flex>
                </div>
                {this.state.error && (
                    <p className="modal-terms-of-use-error">{i18n.t('common:error-retry')}</p>
                )}
                <Flex
                    className="modal-terms-of-use-actions"
                    justifyContent="space-between"
                    alignItems="center"
                    gap="16px"
                >
                    <Button
                        href={i18n.t('url:logout.url')}
                        hierarchy="secondary"
                        isDisabled={this.state.loading}
                    >
                        {i18n.t('common:logout')}
                    </Button>

                    <Button
                        onClick={this.onApprove}
                        isDisabled={!isFormValid || this.state.loading}
                        isLoading={this.state.loading}
                    >
                        {i18n.t('common:accept')}
                    </Button>
                </Flex>
            </Modal.Body>
        );
    }

    render() {
        const { hasViewedTermsOfUseTour } = this.props;

        if (
            hasViewedTermsOfUseTour !== null &&
            !hasViewedTermsOfUseTour &&
            !this.state.show &&
            !this.isOnLegalPage()
        ) {
            this.triggerPopup();
        }

        return (
            <Modal dialogClassName="modal-terms-of-use" show={this.state.show}>
                {this.renderMainBody()}
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    let hasViewedTermsOfUseTour = null;

    if (state?.user?.get('tours')) {
        const hasTours = state?.user?.get('tours').map((t) => t.tour);
        if (hasTours.includes(termsOfUseTourName)) {
            hasViewedTermsOfUseTour = hasTours.includes(termsOfUseTourName);
        } else {
            hasViewedTermsOfUseTour = false;
        }
    }

    return {
        hasViewedTermsOfUseTour
    };
};

const mapDispatchToProps = (dispatch) => ({
    setTourAsViewed: bindActionCreators(setTourAsViewed, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUsePopup);
